import { v4 as uuidv4 } from 'uuid'
import pahoMqtt from './pahomqtt/paho-mqtt'
import { webSockets } from '@/api/config'

global.Paho = {
  MQTT: pahoMqtt
}
function prepareTime () {
  function f (n, l = 2) {
    let temp = `${n}`
    if (temp.length < l)
      for (let i = 0; i < l - 1; i++) temp = `0${temp}`
    return temp
  }

  const temp = new Date()
  return `${f(temp.getHours())}:${f(temp.getMinutes())}:${f(temp.getSeconds())}.${f(temp.getMilliseconds(), 3)}`
}
class WebSockets {
  constructor (config) {
    this.config = config
    this.uuid = uuidv4()
    this.client = new pahoMqtt.Client(this.config.broker, this.config.port, '/ws', this.uuid)
    const listeners = {
      onMessageArrived: new Map(),
      onConnectionLost: new Map()
    }
    this.listeners = listeners
    this.connected = false
    this.connecting = false
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const $this = this
    this.baseOptions = {
      useSSL: JSON.parse(this.config.sslStatus),
      timeout: 20,
      keepAliveInterval: 120,
      userName: this.config.userName,
      password: this.config.password,
      onSuccess (arg) {
        $this.connected = true
        if ($this.scheduledSubscriptions.length) {
          for (const x of $this.scheduledSubscriptions)
            $this.client.subscribe(x, { qos: 1 })
          $this.scheduledSubscriptions = []
        }
      },
      onFailure (arg) {
      }
    }
    this.client.onConnectionLost = arg => {
      for (const [channelName, listener] of listeners.onConnectionLost)
        listener(arg, channelName)
    }

    this.client.onMessageArrived = arg => {
      const targetChannel = arg.destinationName.replace(/\//g, '.')
      for (const [channelName, listener] of listeners.onMessageArrived)
        try {
          if (targetChannel !== channelName) continue
          listener(JSON.parse(arg.payloadString), channelName)
        } catch (ex) {
          // eslint-disable-next-line prefer-object-spread
          const a = Object.assign({}, ex)
          console.error('exception on message taken', ex, a)
        }
    }
    this.scheduledSubscriptions = []
  }

  test (
    channelName,
    onMessageArrived = x => console.log(`${prepareTime()}[${channelName}]message arrived`, x),
    onConnectionLost = x => console.log(`${prepareTime()}[${channelName}]connection lost`, x)
  ) {
    this.subscribe(channelName, onMessageArrived, onConnectionLost)

  }

  subscribe (channelName, onMessageArrived, onConnectionLost) {
    const newListeners = {
      onMessageArrived, onConnectionLost
    }
    for (const x in newListeners)
      if (newListeners[x] && typeof newListeners[x] === 'function')
        if (this.listeners[x].get(channelName) == null)
          this.listeners[x].set(channelName, newListeners[x])

    if (this.connected) {
      this.client.subscribe(channelName, { qos: 1 })
    } else {
      if (!this.connecting) {
        this.client.connect(this.baseOptions)
        this.connecting = true
      }
      this.scheduledSubscriptions.push(channelName)

    }

  }

  unsubscribe (channelName) {
    try {
      this.client.unsubscribe(channelName)
    } catch (ex) {
      // eslint-disable-next-line prefer-object-spread
      const a = Object.assign({}, ex)
      console.error('exception on unsubscribing', ex, a)
    } finally {
      for (const x of ['onMessageArrived', 'onConnectionLost'])
        this.listeners[x].delete(channelName)
    }

  }
}

export default new WebSockets(webSockets)
